import jwt_decode from "jwt-decode";

const token = "MhUserAuthorization";

const auth = {
    getToken: () => localStorage.getItem(token) && localStorage.getItem(token).length >= 128 ? localStorage.getItem(token) : null,
    setToken: (val) => localStorage.setItem(token, `${val}`),
    removeToken: () => localStorage.removeItem(token),
    getMember: () => {
        var result = localStorage.getItem(token) ? localStorage.getItem(token) : null;
        if(result) {
          return jwt_decode(result);
        }
        return { headImageUrl: "", userId: "", userKey: "", userName: "", userType: "" };
    },
};

export default auth;
